{
  "BUSINESS_GARDEN": "Næringshage",
  "INCUBATOR": "Inkubator",
  "SIVA_PROGRAMADMIN": "Siva - Programadmin",
  "OWI_ACTOR": "Én vei inn aktør",
  "NCE_OUTSIDE_NIC": "NCE - Utenfor NIC",
  "NCE": "NCE",
  "ARENA": "Arena",
  "BUSINESS_NETWORK": "Bedriftsnettverk",
  "CLUSTER_INITIATIVE": "Klyngeinitiativ",
  "MODNE_KLYNGER": "Modne klynger",
  "ARENA_PRO": "Arena Pro",
  "NETWORK": "Nettverk",
  "GCE": "GCE",
  "NIC_KLYNGE_2025": "Norwegian Innovation Cluster"
}
